import { getComparisonGranularity, getNumberOfUnitsOrAmount } from '../features/comparison';
import { getMeasureFormatString } from '../features/metricValue';
import { getStaticTargetValue, isDefaultLineStaticRefLine } from '../features/threshold';
import { Messages } from '../localization';
import { DateGranularity, EffectiveDefinition } from '../models';
import { formatValueAsMetricNumber } from './numberFormatter';

export const getAuthoredComparisonText = (definition: EffectiveDefinition): string => {
  if (isDefaultLineStaticRefLine(definition)) {
    const target = getStaticTargetValue(definition);
    const formatString = getMeasureFormatString(definition);
    return target !== undefined ? formatValueAsMetricNumber(target, formatString) : '';
  } else {
    const units = getNumberOfUnitsOrAmount(definition) ?? 1;
    const granularity = getComparisonGranularity(definition) ?? DateGranularity.UNKNOWN;
    return getHistoricalComparisonText(granularity, units);
  }
};

const getHistoricalComparisonText = (date: DateGranularity, units: number): string => {
  switch (date) {
    case DateGranularity.SECOND: {
      return units === 1
        ? Messages.metricsSecondComparisonSingular()
        : Messages.metricsSecondComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.MINUTE: {
      return units === 1
        ? Messages.metricsMinuteComparisonSingular()
        : Messages.metricsMinuteComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.HOUR: {
      return units === 1
        ? Messages.metricsHourComparisonSingular()
        : Messages.metricsHourComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.DAY: {
      return units === 1
        ? Messages.metricsDayComparisonSingular()
        : Messages.metricsDayComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.WEEK: {
      return units === 1
        ? Messages.metricsWeekComparisonSingular()
        : Messages.metricsWeekComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.MONTH: {
      return units === 1
        ? Messages.metricsMonthComparisonSingular()
        : Messages.metricsMonthComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.QUARTER: {
      return units === 1
        ? Messages.metricsQuarterComparisonSingular()
        : Messages.metricsQuarterComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.YEAR: {
      return units === 1
        ? Messages.metricsYearComparisonSingular()
        : Messages.metricsYearComparisonPlural({ value: units.toString() });
    }
    case DateGranularity.UNKNOWN: {
      return units === 1
        ? Messages.metricsMarkComparisonSingular()
        : Messages.metricsMarkComparisonPlural({ value: units.toString() });
    }
    case undefined:
    default: {
      return '';
    }
  }
};
